export const downloadReportFile = async ({ reportUrl, campaignId }) => {
  if (!reportUrl) {
    throw new Error("report_url is required");
  }

  const res = await fetch(reportUrl);

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }

  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `reporte_campana_${campaignId}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
